(function () {
	const header = () => {
		const megaMenuLinks = document.querySelectorAll(".list-menu--parent");
		megaMenuLinks.forEach((link) => {
			link.addEventListener("mouseenter", () => {
				link.classList.add("list-menu--visible");

				link.addEventListener("mousemove", () => {
					link.classList.add("list-menu--visible");
				});

				link.addEventListener("mouseleave", () => {
					setTimeout(() => {
						link.classList.remove("list-menu--visible");
					}, 300);
					link.addEventListener("mouseenter", () => {
						link.classList.add("list-menu--visible");
					});
				});
			});
		});
	};

	document.addEventListener("shopify:section:load", header);

	header();
})();
